import React, { Fragment, useEffect, useState } from 'react';
import { icons } from '../../../assets/icons';
import { TunisiaCities } from '../../../data';
import DeleteConfirmationModal from './ShopDeleteModal';

const ShopFields = ({
	shopFields,
	handleChangeShopForm,
	handleDeleteAddedShop,
	showDeleteModal,
	setShowDeleteModal,
	shopToDeleteIndex,
	setShopToDeleteIndex,
	addField,
}) => {
	const [countries, setCountries] = useState([]);

useEffect(() => {
    fetch('https://cdn.jsdelivr.net/npm/world-countries@4/dist/countries.json')
        .then((res) => res.json())
        .then((data) => {
            const sortedCountries = data
                .map((country) => ({
                    name: country?.name?.common,
                    code: country?.cca3,
                    flag: country?.flag,
                }))
                .filter((country) => country.name && country.code)
                .sort((a, b) => a.name.localeCompare(b.name));
            setCountries(sortedCountries);
        })
        .catch((err) => console.error('Error fetching countries:', err));
}, []);

	const ensureNonNegativeNumber = (e) => {
		const inputValue = parseInt(e.target.value, 10);
		if (inputValue < 0) {
			const newEvent = { ...e, target: { ...e.target, value: '0' } };
			return newEvent;
		}
		return e;
	};

	const handleCountryChange = (id, e) => {
		handleChangeShopForm(id, e);
		// Reset region if country is not Tunisia
		if (e.target.value !== 'TUN') {
			const regionEvent = {
				target: { name: 'region', value: '' },
			};
			handleChangeShopForm(id, regionEvent);
		}
	};

	return (
		<Fragment>
			<div className='add-shop-title'>
				<h2>Liste des boutiques</h2>
				<icons.BsPlusSquareDotted
					style={{ fontSize: '1.3rem', cursor: 'pointer' }}
					title='ajouter une nouvelle boutique'
					onClick={addField}
				/>
			</div>
			{shopFields.map((inputValue, index) => (
				<div className='shop' key={inputValue.id}>
					<div className='del-shop'>
						<div className='box-bordered' title='supprimer cette boutique'>
							<icons.BsTrash
								className='del-shop-icon'
								onClick={() => {
									setShowDeleteModal(true);
									setShopToDeleteIndex(inputValue.id);
								}}
							/>
						</div>
					</div>
					<label>Nom de boutique</label>
					<input
						type='text'
						placeholder='Nom de boutique'
						name='name'
						value={inputValue.name}
						onChange={(e) => handleChangeShopForm(inputValue.id, e)}
						required
					/>
					<div className='delivery-details'>
						<label>Adresse</label>
						<div className='info-1'>
							<input
								type='number'
								placeholder='Numéro'
								name='address_number'
								value={parseInt(inputValue.address_number, 10).toString()}
								onChange={(e) => handleChangeShopForm(inputValue.id, ensureNonNegativeNumber(e))}
								onWheel={(e) => e.currentTarget.blur()}
								required
							/>
							<input
								type='text'
								placeholder='Rue'
								name='street'
								value={inputValue.street}
								onChange={(e) => handleChangeShopForm(inputValue.id, e)}
								required
							/>
						</div>
						<div className='info-1'>
							<input
								type='text'
								placeholder='Ville'
								name='ville'
								value={inputValue.ville}
								onChange={(e) => handleChangeShopForm(inputValue.id, e)}
								required
							/>
							<input
								type='text'
								placeholder='Code postal'
								name='postal_code'
								value={inputValue.postal_code}
								onChange={(e) => handleChangeShopForm(inputValue.id, e)}
								required
							/>
						</div>
						<div className='info-dropdown'>
							<select
								name='country'
								value={inputValue.country || ''}
								onChange={(e) => handleCountryChange(inputValue.id, e)}
							>
								<option value=''>Choisir un pays</option>
								{countries.map((country, index) => (
									<option key={index} value={country.code}>
										{country.flag} {country.name}
									</option>
								))}
							</select>
						</div>
						{inputValue.country === 'TUN' && (
							<div className='info-dropdown'>
								<select
									required
									name='region'
									value={inputValue.region}
									onChange={(e) => handleChangeShopForm(inputValue.id, e)}
								>
									<option value=''>Choisir un gouvernorat</option>
									{TunisiaCities.map((city, index) => (
										<Fragment key={index}>
											<option value={city.name}>{city.name}</option>
										</Fragment>
									))}
								</select>
							</div>
						)}
					</div>
					{showDeleteModal && shopToDeleteIndex === inputValue.id && (
						<DeleteConfirmationModal
							onDelete={() => {
								handleDeleteAddedShop(shopToDeleteIndex);
								setShowDeleteModal(false);
							}}
							onCancel={() => setShowDeleteModal(false)}
						/>
					)}
				</div>
			))}
		</Fragment>
	);
};

export default ShopFields;